import React, { useMemo } from 'react';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import { ALLOWED_EXTERNAL_CONTROLS } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/constants.tsx';
import type { ExternalControlsType } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import { useExternalControlsAPI } from '../../../../controllers/use-external-controls-api/index.tsx';
import type { FormAPI } from '../../../../controllers/use-external-controls-api/types.tsx';

type Props = {
	externalControls: ExternalControlsType;
} & FormAPI;

const Controls = ({ externalControls, getFormState, setFieldValue }: Props) => {
	const formAPI = useMemo(
		() => ({
			getFormState,
			setFieldValue,
		}),
		[getFormState, setFieldValue],
	);
	const { fieldAPI, getFormFieldValue } = useExternalControlsAPI(formAPI);
	const { Component } = externalControls;

	return <Component fieldAPI={fieldAPI} getFormFieldValue={getFormFieldValue} />;
};

export const ExternalControlsRenderer = ({
	externalControls,
	getFormState,
	setFieldValue,
}: Partial<Props>) => {
	if (
		externalControls &&
		getFormState &&
		setFieldValue &&
		ALLOWED_EXTERNAL_CONTROLS.TRIGGER_POINTS.includes(externalControls.triggerPoint)
	) {
		return (
			<JiraIssueCreateErrorBoundary
				id="externalControlsRenderer"
				packageName="jiraIssueCreate"
				fallback="unmount"
			>
				<Controls
					externalControls={externalControls}
					getFormState={getFormState}
					setFieldValue={setFieldValue}
				/>
			</JiraIssueCreateErrorBoundary>
		);
	}

	return null;
};
